// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Staff from "admin/Hr/Staff";
import Setup from "admin/Setup";
import ERPSetup from "client/ERPSetup";
import LookUp from "client/LookUp";
import Upload from "client/Upload";
import Exams from "admin/Exams";
import Office from "admin/Office";
import Approval from "admin/Approval";
import Valuation from "admin/Valuation";
import Fee from "admin/Fee";
import Student from "admin/Student";
import FeeCategory from "client/ERPSetup/FeeCategory";
import Client from "admin/Setup/Client";
import AdvExp from "admin/Adv&Exp";
import Library from "admin/Library";
// @mui icons
import Icon from "@mui/material/Icon";

// Suggested icons for each menu
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>, // 📊 Dashboard
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Staff",
    key: "staff",
    icon: <Icon fontSize="small">groups</Icon>, // 👥 Staff
    route: "/staff",
    component: <Staff />,
  },
  /* {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>, // 👤 Profile
    route: "/profile",
    component: <Profile />,
  }, */
  {
    type: "collapse",
    name: "Approvals",
    key: "approvals",
    icon: <Icon fontSize="small">build</Icon>, // 🔧 Setup
    route: "/admin/approval",
    component: <Approval />,
  },
  {
    type: "collapse",
    name: "Valuation",
    key: "valuation",
    icon: <Icon fontSize="small">build</Icon>, // 🔧 Setup
    route: "/admin/valuation",
    component: <Valuation />,
  },

  {
    type: "collapse",
    name: "Setup",
    key: "setup",
    icon: <Icon fontSize="small">build</Icon>, // 🔧 Setup
    route: "/admin/setup",
    component: <Setup />,
  },
  {
    type: "collapse",
    name: "ERP Setup",
    key: "erp-setup",
    icon: <Icon fontSize="small">tune</Icon>, // ⚙️ ERP Setup
    route: "/client/erpsetup",
    component: <ERPSetup />,
  },
  {
    type: "collapse",
    name: "Upload",
    key: "upload",
    icon: <Icon fontSize="small">cloud_upload</Icon>, // ☁️ Upload
    route: "/client/upload",
    component: <Upload />,
  },
  {
    type: "collapse",
    name: "LookUp",
    key: "lookup",
    icon: <Icon fontSize="small">search</Icon>, // 🔍 Lookup
    route: "/client/lookup",
    component: <LookUp />,
  },
  {
    type: "collapse",
    name: "Student",
    key: "student",
    icon: <Icon fontSize="small">build</Icon>, // 🔧 Setup
    route: "/admin/student",
    component: <Student />,
  },
  {
    type: "collapse",
    name: "Office",
    key: "office",
    icon: <Icon fontSize="small">business</Icon>, // 🏢 Office
    route: "/admin/office",
    component: <Office />,
  },
  {
    type: "collapse",
    name: "Fee",
    key: "fee",
    icon: <Icon fontSize="small">currency_rupee</Icon>, // 🏢 Fees
    route: "/admin/fee",
    component: <Fee />,
  },
  {
    type: "collapse",
    name: "Advance & Expense",
    key: "adv-exp",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/admin/adv-exp",
    component: <AdvExp />,
  },
  {
    type: "collapse",
    name: "Library",
    key: "library",
    icon: <Icon fontSize="small">menu_book</Icon>,
    route: "/admin/library",
    component: <Library />,
  },
  {
    type: "collapse",
    name: "Exams",
    key: "exams",
    icon: <Icon fontSize="small">school</Icon>, // 🎓 Exams
    route: "/admin/exams",
    component: <Exams />,
  },

  {
    type: "collapse",
    name: "Fee Category",
    key: "feecategory",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>, // 💰 Fee Category
    route: "/client/erpsetup/feecategory",
    component: <FeeCategory />,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
    icon: <Icon fontSize="small">login</Icon>, // 🔑 Sign In
  },
  /* {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up",
    component: <SignUp />,
    icon: <Icon fontSize="small">person_add</Icon>, // ➕ User Sign Up
  }, */
  {
    type: "collapse",
    name: "Client Setup",
    key: "client-setup",
    icon: <Icon fontSize="small">supervisor_account</Icon>, // 🧑‍💼 Client Setup
    route: "admin/setup/client",
    component: <Client />,
  },
];

export default routes;
